import { redirect } from '@tanstack/react-router'
import { toast } from 'sonner'
import { useAuthStore } from '@/lib/auth'
import { grants, type PermissionRequirement } from '@/lib/permissions'
import { ROUTES } from '@/lib/routes'

/** Mensaje al intentar abrir una pantalla sin permiso. */
const FORBIDDEN_MESSAGE = 'No tiene permiso para ver esa sección.'

/**
 * `beforeLoad` que exige un permiso para entrar a la ruta; si falta,
 * redirige al panel con un aviso. Úselo en cada ruta protegida:
 * `beforeLoad: requirePermission('clients:read')`.
 * (El API vuelve a validar: esto es solo experiencia de usuario.)
 */
export function requirePermission(requirement: PermissionRequirement) {
  return () => {
    const permissions = useAuthStore.getState().employee?.permissions
    if (!grants(permissions, requirement)) {
      toast.error(FORBIDDEN_MESSAGE)
      throw redirect({ to: ROUTES.dashboard })
    }
  }
}
